import { render, staticRenderFns } from "./PollstarEventsv2.vue?vue&type=template&id=4ee39613&"
import script from "./PollstarEventsv2.vue?vue&type=script&lang=js&"
export * from "./PollstarEventsv2.vue?vue&type=script&lang=js&"
import style0 from "./PollstarEventsv2.vue?vue&type=style&index=0&id=4ee39613&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports